exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".swiper{width:100%;height:100%}.custom-prev,.custom-next{width:40px;height:40px;background-color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 5px rgba(0,0,0,.1);color:#3498db;border:none}.swiper-button-next,.swiper-button-prev{display:none !important}", ""]);

